import React from 'react';


import { BrowserRouter, Routes, Route} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";


import { ThemeProvider, createTheme } from '@mui/material/styles';




import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import EgressWindows from './pages/EgressWindows';
import EgressBlogPosts from './pages/EgressBlogPosts';
import PostPage from './pages/PostPage';
import ProfilePage from './pages/ProfilePage';
import EgressWindowProducts from './pages/EgressWindowProducts';
import ProductPage from './pages/ProductPage';






// Import your pages and components here

const theme = createTheme({
  palette: {
    background: {
      default: '#121212', // Page background color
      paper: 'rgba(0,0,0,0.8)', // Footer, header, and grid sections background color
    },
    primary: {
      main: '#ffffff', // Text and icons on the drawer (white)
    },
    secondary: {
      main: '#0deb2a', // Titles and text on the tan background (black)
    },
    drawer: {
      main: 'rgba(0,0,0,0.9)', // Navigation drawer background color
      text: '#ffffff', // Text on the drawer (white)
    },
  },
  spacing: [4, 0, 1, 8, 6, 5, 10],
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
     
        
        <ScrollToTop>
        <Routes>
      
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/contact-us' element={<Contact />} />
          <Route path='/egress-windows' element={<EgressWindows/>}/> 
          <Route path='/egress-window-products' element={<EgressWindowProducts/>}/>
          <Route path='/egress-blog' element={<EgressBlogPosts/>}/>
          <Route path='/post-page/:id' element={<PostPage/>} ></Route>
          <Route path='/profile-page/:id' element={<ProfilePage/>}></Route>
          <Route path='/product-page/:id' element={<ProductPage/>}></Route>
          <Route path='/egress-window-systems'></Route>
          <Route path='/egress-gallery'>
          <Route path='/inswing-egress-window'>
         
         
          
        
        </Routes>
    </ScrollToTop>
      </BrowserRouter>
      
    </ThemeProvider>
  );
}

export default App;



